/**
 * Custom collapse.
 */
jQuery('.toggle-woocommerce-header').on('click', function (e) {
	e.preventDefault();
	jQuery(this).toggleClass('open');
	jQuery('.woocommerce-products-header').toggleClass('open');
});

/**
 * Swiper Sliders
 */
const heroSwiper = new Swiper(".hero-swiper", {
	spaceBetween: 30,
	centeredSlides: true,
	loop: true,
	autoplay: {
		delay: 4000,
		disableOnInteraction: false,
	}
});

/**
 * Submenu Toggles
 */
jQuery('.dropdown-toggle').on('click', function (e) {
	if (jQuery(window).width() > 990) {
		if (typeof jQuery(this).attr('href') != 'undefined' && jQuery(this).attr('href') !== '#') {
			window.location.href = jQuery(this).attr('href');
		}
	}
});

/**
 * Infinite Scroll
 */
if (jQuery('.next').length) {
	jQuery('ul.products').infiniteScroll({
		path: '.next',
		append: '.product',
		history: false,
		status: '.page-load-status',
	});
}

/**
 * Navbar Toggler.
 */
jQuery(document).on("click", ".navbar-toggler", function (e) {
	e.preventDefault();
	jQuery(this).toggleClass('open');
});

/**
 * Data Clickable
 */
jQuery(document).on('click', '[data-clickable]', function () {
	window.location.href = jQuery(this).data("clickable");
});

jQuery('[data-order]').each(function () {
	jQuery(this).css('order', jQuery(this).data('order'));
});

/**
 * Document ready functionality
 */
jQuery(document).ready(function () {

	/**
	 * Caluclate shipping button.
	 */
	setTimeout(function () {
		const $calculateShippingButton = jQuery('#wc-block-components-totals-shipping__change-address__link');
		if ($calculateShippingButton.length) {
			$calculateShippingButton.html('Calculate Shipping');
		}
	}, 1000);

	/**
	 * Smooth scroll to the anchor id.
	 */
	if (window.location.hash) {
		jQuery('html, body').animate({
			scrollTop: jQuery(window.location.hash).offset().top
		}, 800);
	}

	/**
	 * Product Customisations.
	 */

	// Frame Heights
	jQuery('[name="frame_heights"]').on('change', function () {
		jQuery('[name="frame_height_row"]').val(jQuery('[name="frame_heights"]').find(':selected').data('row'));
	});

	// Decking Styles
	jQuery('[name="decking_styles"]').on('change', function () {
		jQuery('[name="decking_style_row"]').val(jQuery('[name="decking_styles"]').find(':selected').data('row'));
	});

	// Beam Lengths
	jQuery('[name="beam_lengths"]').on('change', function () {
		const length = jQuery(this).find(':selected').val();
		jQuery('[name="beam_row"]').val(jQuery('[name="beam_lengths"]').find(':selected').data('row'));
		jQuery('[name="decking_styles"]').val("");
		jQuery('[name="decking_style_row"]').val('');
		jQuery('[name="decking_styles"] option:not(.default)').each(function () {
			if (jQuery(this).data('length') == length) {
				jQuery(this).removeClass('length-excluded');
			} else {
				jQuery(this).addClass('length-excluded');
			}
		});
	});

	// Frame Depths
	jQuery('[name="frame_depths"]').on('change', function () {
		const depth = jQuery(this).find(':selected').val();
		jQuery('[name="frame_depth_row"]').val(jQuery('[name="frame_depths"]').find(':selected').data('row'));
		jQuery('[name="decking_styles"]').val("");
		jQuery('[name="decking_style_row"]').val('');
		jQuery('.exclude-depth').removeClass('decking-excluded')
		jQuery('.exclude-depth.' + depth).addClass('decking-excluded');
	});

	// Totals
	jQuery('#calculate-total').click(function (e) {
		// Frames
		const frames = jQuery('[name="no_of_frames"]').val();
		const frame_cost = jQuery('[name="no_of_frames"]').data('price');
		const frame_height = jQuery('[name="frame_heights"]').val();
		let total_frame_cost = 0;

		if (frames && frame_cost && frame_height) {
			const frame_height_cost = frame_cost * (frame_height / 1000);
			total_frame_cost = frame_height_cost * frames;
		}

		// Beams
		const beams = jQuery('[name="no_of_beams"]').val();
		const selected_beam_price = jQuery('[name="beam_lengths"]').find(':selected').data('price');
		let total_beam_cost = 0;
		if (beams && selected_beam_price) {
			total_beam_cost = selected_beam_price * beams;
		}

		// Decking
		const selected_decking_price = jQuery('[name="decking_styles"]').find(':selected').data('price');
		let total_decking_cost = 0;

		if (selected_decking_price) {
			total_decking_cost = selected_decking_price * (beams / 2);
		}

		// Total Cost
		if (total_frame_cost && total_beam_cost) {
			const total = parseFloat(total_frame_cost + total_beam_cost + total_decking_cost).toFixed(2);
			jQuery('.error-message').addClass('d-none');
			jQuery('.custom-price').html('£' + total);
		} else {
			jQuery('.error-message').removeClass('d-none');
		}
	});

});
